<div class="error-content bg-white">
  <div class="error-text-container">
    <div class="header">
      {{ header |translate}}
    </div>
    <div class="body-text">
      {{ body |translate }}
    </div>
    <button mat-flat-button color="primary" class="back-button" (click)="returnToHome()">{{"HTTP_ERROR.RETURN" | translate}}</button>
  </div>
  <div class="background-text">
    {{errorCode}}
  </div>
</div>
